// libs
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

// defs
import { IColorOptions } from './types';
import { IColorOption as ITransformedColorVariant } from 'shared/components/ColorSwatchesPDP/types';

export const getColorOptions = (skuData?: ProductDetail.ISkuData) => {
  return get(skuData, 'product.colorOptions', []);
};

export const getDefaultColor = (skuData?: ProductDetail.ISkuData) => {
  return get(skuData, 'product.color');
};

export const getCurrentImage = (skuData?: ProductDetail.ISkuData) => {
  return get(skuData, 'product.imageUrl', '');
};

export const getAspectRatio = (skuData?: ProductDetail.ISkuData) => {
  return get(skuData, 'product.productMedia[0].aspect_ratio');
};

export interface IColorOption {
  actionUrl: string;
  colorCode?: string;
  imageUrl: string;
  inStock: boolean;
  name: string;
  aspectRatio: number;
  isSelected: boolean;
}

export const transformColorVariants = ({
  defaultColor,
  colorOptions,
  currentImage,
  aspectRatio,
  currentUrl,
  isCurrentInStock,
}: IColorOptions) => {
  // return empty array if default Color or colorOptions are empty
  if (isEmpty(defaultColor) || isEmpty(colorOptions)) {
    return [];
  }

  const defaultColorOption = {
    ...defaultColor,
    actionUrl: currentUrl,
    aspectRatio: aspectRatio,
    inStock: isCurrentInStock,
    isSelected: true,
    imageUrl: currentImage,
  };

  const transformedVariants: { [key: string]: ITransformedColorVariant[] } = {
    inStock: [],
    outOfStock: [],
  };

  // transform all color options
  colorOptions.forEach((colorOption) => {
    const transformedOption = {
      actionUrl: colorOption.action_url,
      colorCode: colorOption.colorCode,
      imageUrl: colorOption.image_url,
      inStock: colorOption.in_stock,
      name: colorOption.name,
      aspectRatio: aspectRatio,
      isSelected: false,
    };

    if (transformedOption.inStock) {
      transformedVariants.inStock.push(transformedOption);
    } else {
      transformedVariants.outOfStock.push(transformedOption);
    }
  });

  return [defaultColorOption, ...transformedVariants.inStock, ...transformedVariants.outOfStock];
};
